import * as UIKit from '@esgi/ui-kit/selectors';

const Selectors = {
	UIKit: UIKit.default,
	Preloader: 'preloader',
};

export default Selectors;
